module.exports = "/static/assets/9866ab77b90e2820a7c9ad2ad42b63fd.png";